import _classNames from 'clsx';
import React from 'react';
import Button from '../button/button';

export type ChipType = 'default' | 'warning' | 'sim';
export type OnDeleteFunc = (text: string) => void;

interface ChipProps {
  type?: ChipType;
  text: string;
  classes?: string;
  onDelete?: OnDeleteFunc;
}

function Chip(props: ChipProps) {
  const { classes = '', text, type = 'default', onDelete } = props;

  return (
    <div className={_classNames('Chip', `Chip--type-${type}`, classes)}>
      <span className="Chip__text">{text}</span>
      {typeof onDelete === 'function' && (
        <div>
          <Button
            classes="Chip--type-sim__button"
            iconRight="Close"
            iconRightColor="white"
            buttonProps={{ type: 'button' }}
            onClick={() => onDelete(text)}
          />
        </div>
      )}
    </div>
  );
}

export default Chip;
